// extracted by css-extract-rspack-plugin
export default {"cls1":"TransactionalPricingModal-cls1_Hj1","cls2":"TransactionalPricingModal-cls2_smM TransactionalPricingModal-cls1_Hj1"};